import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { DATASET_KEY } from '@/utils/queryKeys.ts';
import { Dataset } from '@/types/datasets.ts';

const useInvalidateDataset = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (dataset: Dataset): unknown[][] => {
      queryClient.setQueryData<Dataset>(DATASET_KEY(dataset.id), dataset);
      return [];
    },
    [queryClient],
  );
};

export default useInvalidateDataset;
